export default function getBlogPostingSchema({ title, subtitle, date, image, markdown, slug }) {
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": title,
    "description": subtitle,
    "image": image,
    "author": {
      "@type": "Person",
      "name": "Denis Bitter"
    },
    "publisher": {
      "@type": "Organization",
      "name": "ZenLearn",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.denisbitter.de/logo.png"
      }
    },
    "datePublished": date,
    "articleBody": markdown,
    "mainEntityOfPage": `https://www.denisbitter.de/blog/${slug}`
  };
}
